<div class="card">
    <form [formGroup]="frmForm" (ngSubmit)="saveFrmDetails()">
        <h2>Fraud Risk Management</h2>
        <div class="row">
            <div class="column">
                <label>Merchant</label>
                <ng-select id="merchantPayId"
                    placeholder="Select a Merchant"
                    [clearable]="false"
                    [formControlName]="'merchantPayId'"
                    (change)="onMerchantChange($event)">
                    <ng-option value disabled>Select a Merchant</ng-option>
                    <ng-option *ngFor="let merchant of merchants"
                        [value]="merchant.payId">
                        {{ merchant.businessName }}
                    </ng-option>
                </ng-select>

            </div>

            <!-- <div class="column">
                <label>Currency</label>
                <select id="currency" formControlName="currency"
                    (change)="onCurrencyChange($event)">
                    <option value disabled>Select a Currency</option>
                    <option *ngFor="let currency of currencies"
                        [value]="currency.code">
                        {{ currency.name }}
                    </option>
                </select>
            </div> -->

            <div class="column">
                <label for="mop">Payment Type</label>
                <select id="mop" formControlName="mop"
                    (change)="onPaymentTypeChange($event)">
                    <option value disabled selected>Select a Payment
                        Type</option>
                    <option *ngFor="let type of paymentTypes"
                        [value]="type.code">{{ type.name }}</option>
                </select>
            </div>
        </div>

        <div class="row">
            <div class="column">
                <span>Min. Amount Per Transaction: <i class="currencySymbol"
                        style="font-size: large; font-weight: bolder; color: black;">{{
                        currencySymbol }}</i></span>
                <input type="text" id="minTicketSize"
                    formControlName="minTicketSize"
                    placeholder="Min Amount" >
            </div>

            <div class="column">
                <span>Max. Amount Per Transaction: <i class="currencySymbol"
                        style="font-size: large; font-weight: bolder; color: black;">{{
                        currencySymbol }}</i></span>
                <input type="text" id="maxTicketSize"
                    formControlName="maxTicketSize"
                    placeholder="Max Amount" >
            </div>

            <div class="column">
                <label for="merchantProfile"
                    class="d-flex align-items-center fs-6 fw-bold mb-2">
                    <span>Merchant Profile</span>
                </label>
                <select formControlName="merchantProfile"
                    class="form-select form-select-solid" id="merchantProfile"
                    [disabled]="true">
                    <option *ngFor="let profile of ['low', 'moderate', 'high']"
                        [value]="profile">{{ profile | titlecase }}</option>
                </select>
            </div>
        </div>

        <div class="row">
            <div class="column">
                <span>Max. Amount Limit Per Day: <i class="currencySymbol"
                        style="font-size: large; font-weight: bolder; color: black;">{{
                        currencySymbol }}</i></span>
                <input type="text" id="mopDaily"
                    formControlName="mopDaily"
                    placeholder="Daily Transaction Limit">
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                    <span>Remaining: <i id="monthlyBalance"
                            style="color: rgb(43, 43, 43);">{{
                            frmForm.get('mopDaily')?.value || 0
                            }}</i></span>
                </label>
            </div>

            <div class="column">
                <span>Max. Amount Limit Per Week: <i class="currencySymbol"
                        style="font-size: large; font-weight: bolder; color: black;">{{
                        currencySymbol }}</i></span>
                <input type="text" id="mopWeekly"
                    formControlName="mopWeekly"
                    placeholder="Weekly Transaction Limit">
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                    <span>Remaining: <i id="weeklyBalance"
                            style="color: rgb(43, 43, 43);">{{
                            frmForm.get('mopWeekly')?.value || 0
                            }}</i></span>
                </label>
            </div>

            <div class="column">
                <span>Max. Amount Limit Per Month: <i class="currencySymbol"
                        style="font-size: large; font-weight: bolder; color: black;">{{
                        currencySymbol }}</i></span>
                <input type="text" id="mopMonthly"
                    formControlName="mopMonthly"
                    placeholder="Monthly Transaction Limit">
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                    <span>Remaining: <i id="monthlyBalance"
                            style="color: rgb(43, 43, 43);">{{
                            frmForm.get('mopMonthly')?.value || 0
                            }}</i></span>
                </label>
            </div>
        </div>

        <div class="row">
            <div class="column">
                <label for="weekTransactionCount">Max. Transaction Count Per
                    Day</label>
                <input type="text" id="daily"
                    formControlName="daily"
                    placeholder="Daily Volume">
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                    <span>Remaining: <i id="dailyBalance"
                            style="color: rgb(43, 43, 43);">{{
                            frmForm.get('daily')?.value || 0
                            }}</i></span>
                </label>
            </div>

            <div class="column">
                <label for="weekly">Max. Transaction Count
                    Per Week</label>
                <input type="text" id="weekly"
                    formControlName="weekly"
                    placeholder="Weekly Volume">
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                    <span>Remaining: <i id="weeklyBalance"
                            style="color: rgb(43, 43, 43);">{{
                            frmForm.get('weekly')?.value ||
                            0 }}</i></span>
                </label>
            </div>

            <div class="column">
                <label for="monthly">Max. Transaction Count
                    Per Month</label>
                <input type="text" id="monthly"
                    formControlName="monthly"
                    placeholder="Monthly Volume">
                <label class="d-flex align-items-center fs-6 fw-bold mb-2">
                    <span>Remaining: <i id="monthlyBalance"
                            style="color: rgb(43, 43, 43);">{{
                            frmForm.get('monthly')?.value ||
                            0 }}</i></span>
                </label>
            </div>
        </div>

        <button type="submit">Save</button>
    </form>
</div>
